import type { RouteRecordRaw } from "vue-router";

export default [
  {
    path: "/",
    name: "auth_home",
    component: () => import("../pages/HomePage.vue"),
  },
  {
    path: "/login",
    name: "auth_login",
    component: () => import("../pages/LoginPage.vue"),
  },
  {
    path: "/confirm/:token?",
    name: "auth_confirm",
    component: () => import("../pages/ConfirmPage.vue"),
  },
  {
    path: "/forgot-password",
    name: "auth_forgot_password",
    component: () => import("../pages/ForgotPasswordPage.vue"),
  },
  {
    path: "/reset-password/:token?",
    name: "auth_reset_password",
    component: () => import("../pages/ResetPasswordPage.vue"),
  },
  {
    path: "/submission-confirmed",
    name: "auth_submission_confirmed",
    component: () => import("../pages/SubmissionConfirmedPage.vue"),
  },
] satisfies RouteRecordRaw[];
